import { IGeocodingTask } from '~src/geocoding/requests/GeocodingBackgrounderRequests';

import { MapperHelper } from '../../../spacesPlatform/models/mappers/MapperHelper';
import { GeocodingTaskInfo } from '../GeocodingTaskInfo';

export module GeocodingTaskMapper {
  const M = MapperHelper;

  export function map(
    tasks: IGeocodingTask[],
  ): GeocodingTaskInfo[] {
    return tasks.map((task: IGeocodingTask): GeocodingTaskInfo => {
      const taskInfo: GeocodingTaskInfo = {
        id: task.id,
        geocodingConfigLuid: task.configLuid,
        geocodingConfigName: task.configName,
        contentType: 'addressGeocodingTask',
        priority:    task.priority,
        unifiedDataConnectionId: task.unifiedDataConnectionId,
        lastRunAt:   M.toDate(task.lastRunAt),
        runNextAt:   M.toDate(task.runNextAt),
      };
      return taskInfo;
    });
  }
}
